import request from 'superagent'

import {
  GET_MODULES_SUCCESS,
  GET_MODULES_ERROR,
  SET_VIDSIZE_SUCCESS,
  SET_VOLUNTARY_SUCCESS,
  SET_FEEDBACK,
  SUBMIT_FEEDBACK_SUCCESS,
  SUBMIT_FEEDBACK_ERROR,
  GET_FEEDBACK_GROUP_SUCCESS,
  GET_FEEDBACK_GROUP_ERROR,
  GET_VIDEOS_SUCCESS,
  GET_VIDEOS_ERROR,
  FEEDBACK_COMPLETE
} from '../constants'

export const showConfirmation = () => {
  $('#feedbackForm').cbModal('hide')
  $('#feedbackConfirm').cbModal('show')
}

export const setVidSize = (size) => {
  return {
    type: SET_VIDSIZE_SUCCESS,
    size
  }
}

export const setVoluntary = (voluntary) => {
  return {
    type: SET_VOLUNTARY_SUCCESS,
    voluntary
  }
}

export const setFeedback = feedback => {
  return {
    type: SET_FEEDBACK,
    feedback
  }
}

export const submitFeedbackSuccess = success => {
  return {
    type: SUBMIT_FEEDBACK_SUCCESS,
    success: success
  }
}

export const submitFeedbackError = (success, error) => {
  return {
    type: SUBMIT_FEEDBACK_ERROR,
    error: error,
    success: success
  }
}

export const submitFeedbackCMP = params => {
  const url = '/cb/webapi/secure/feedback/save'
  let csrfToken = document.getElementsByName('CSRF_TOKEN')[0].value

  return dispatch => {
    request
      .post(url)
      .type('form')
      .send({ CSRF_TOKEN: csrfToken })
      .send({ moduleId: params.moduleId })
      .send({ voluntary: params.voluntary })
      .send({ message: params.message })
      .send({ legacy: true })
      .end((err, res) => {
        if (err) {
          dispatch(submitFeedbackError(false, err))
        } else {
          dispatch(submitFeedbackSuccess(true))
          showConfirmation()
        }
      })
  }
}

export const submitFeedback = params => {
  const url = '/eci/feedback'
  return dispatch => {
    request
      .post(url)
      .type('json')
      .send({ params: params })
      .send({ _csrf: CSRFToken })
      .end((err, res) => {
        if (err) {
          dispatch(submitFeedbackError(false, err))
        } else {
          dispatch(submitFeedbackSuccess(true))
          showConfirmation()
        }
      })
  }
}

export const feedbackComplete = complete => {
  return {
    type: FEEDBACK_COMPLETE,
    complete
  }
}

export const getCustomerFeedbackGroup = moduleId => {
  const url = '/eci/feedbackbycustomer'
  return dispatch => {
    request
      .get(url)
      .query(moduleId)
      .then(res => {
        dispatch(getFeedbackGroupSuccess(res.data))
      }).catch(err => {
        dispatch(getFeedbackGroupError(err))
      })
  }
}

export const getVideos = moduleId => {
  const url = '/eci/video'
  return dispatch => {
    request
      .get(url)
      .query(moduleId)
      .then(res => {
        dispatch({
          type: GET_VIDEOS_SUCCESS,
          videoModule: res.data
        })
      })
      .catch(err =>{
        dispatch ({
          type: GET_VIDEOS_ERROR,
          error: err
        })
      })
  }
}

export const getFeedbackGroupSuccess = feedbackGroup => {
  return {
    type: GET_FEEDBACK_GROUP_SUCCESS,
    feedbackGroup
  }
}

export const getFeedbackGroupError = err => {
  return {
    type: GET_FEEDBACK_GROUP_ERROR,
    error: err,
    text: 'Unable to get feedback group!',
  }
}

const getModulesError = err => {
  return {
    type: GET_MODULES_ERROR,
    error: err,
    success: false
  }
}

const getModulesSuccess = modules => {
  return {
    type: GET_MODULES_SUCCESS,
    modules
  }
}

export const getModules = () => {
  const url = '/eci/feedback/modules'
  return dispatch => {
    request
      .get(url)
      .then(res => {
        if (res.data.error) {
          dispatch(getModulesError(res.data.error))
        } else {
          dispatch(getModulesSuccess(res.data))
        }
      }).catch(err => {
        dispatch(getModulesError(err))
      })
  }
}
